import { observer } from 'mobx-react';
import { useEffect, useRef } from 'react';
import { useStore } from '../../../hooks';
import { DocumentSigningContent } from './documentSigningContent';
import { SignatureFieldHandle } from '@roc/ui';

export const DocumentSigningNoVerification = observer(() => {
  const { wireAuthorizationStore, globalStore } = useStore();
  const formValues = wireAuthorizationStore.getFormValues();
  const signatureRef = useRef<SignatureFieldHandle>(null);

  useEffect(() => {
    wireAuthorizationStore.setLoading(false);
  }, []);

  const handleSubmit = () => {
    if (!signatureRef.current.isSigned()) {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please sign the document before submitting it',
      });
      return;
    }
    if (!wireAuthorizationStore.identityDocumentFront || !wireAuthorizationStore.identityDocumentBack) {
      globalStore.notificationStore.showErrorNotification({
        message: 'Please upload the front and back of your identification document before submitting it',
      });
      return;
    }
    const signatureURL = signatureRef.current.getSignature();
    wireAuthorizationStore.confirmNoVerification(signatureURL,
      {
        accountName: formValues.accountName,
        routingNumber: formValues.routingNumber,
        accountNumber: formValues.accountNumber,
        bankName: formValues.bankName,
        streetName: formValues.streetName,
        city: formValues.city,
        zipCode: formValues.zipCode,
        state: formValues.state,
        ffcAccountName: formValues.fccAccountName,
        ffcRoutingNumber: formValues.fccRoutingNumber,
        ffcAccountNumber: formValues.fccAccountNumber,
        ffcBankName: formValues.fccBankName,
        ffcStreetName: formValues.fccStreetName,
        fccCity: formValues.fccCity,
        fccZipCode: formValues.fccZipCode,
        fccState: formValues.fccState
      }
    );
  };

  return (
    <>
      <DocumentSigningContent
        signatureRef={signatureRef}
        handleSubmit={handleSubmit}
      />
    </>
  );
});
